<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue">User Contact</span>
  </h4>
  <div
    class="jumbotron"
    style="margin-left: 150px; width: 80%; text-align: middle"
  >
    <h1 class="display-4">John Doe</h1>
    <p class="lead">
      The users contact information shown below should be used.
    </p>
    <hr class="my-4" />
    <ul style="list-style: none">
      <li>Email: abc@def.com</li>
      <li>Phone: (555)555-555</li>
      <li>Address: New Jersey Ave</li>
    </ul>
    <hr class="my-4" />
    <p>Registration Progress:</p>
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        style="width: 15%"
        aria-valuenow="15"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
      <div
        class="progress-bar bg-success"
        role="progressbar"
        style="width: 60%"
        aria-valuenow="30"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
      <div
        class="progress-bar bg-info"
        role="progressbar"
        style="width: 20%"
        aria-valuenow="20"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script>
import "../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
export default {};
</script>

<style></style>
